import { DocumentData, FirestoreDataConverter } from 'firebase/firestore'

export class Vendor {
  id: string
  name: string
  logo: string
  address: string
  phone: string
  email: string
  createdAt: Date
  updatedAt: Date

  constructor () {
    this.name = ''
    this.logo = ''
    this.address = ''
    this.phone = ''
    this.email = ''
    this.createdAt = new Date()
    this.updatedAt = new Date()
  }
}

export const vendorConverter: FirestoreDataConverter<Vendor, DocumentData> = {
  toFirestore(vendor: Vendor) {
    vendor.createdAt = vendor.createdAt ? new Date(vendor.createdAt) : new Date()
    vendor.updatedAt = new Date()

    return Object.assign({}, vendor)
  },

  fromFirestore(snapshot, options) {
    const data = snapshot.data(options)
    data.createdAt = (typeof data.createdAt === 'object') ? data.createdAt.toDate() : data.createdAt
    data.updatedAt = (typeof data.updatedAt === 'object') ? data.updatedAt.toDate() : data.updatedAt
    
    return Object.assign(new Vendor(), data)
  }
}
